import KickImage from 'Reuseables/KickImage';
import classNames from "classnames";
import { Component } from "react";
import { connect } from "react-redux";
import LoadingBar from "react-redux-loading-bar";
import { Switch } from "react-router-dom";
// import Footer from './FooterGreen';
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { getKickFairSetting } from "../../actions/kafairAction";
import { getSpinningWheel, getSpinningWheelPrize } from "../../actions/productAction";
import ConnectionError from "../../images/no-connection.png";
import { SHOW_TRIGGER_DOWNLOAD_MODAL } from "../../utils/Constants";
import { getCloudImageUrl } from "../../utils/Helpers";
import Router from "../AppRoute/Route";
import PageMaintenance from "../PageMaintenance";
import ComponentWrapper from "./ComponentWrapper";
import FooterRaffle from "./FooterRaffle";
import FooterBlack from "./FooterV3";
import Navbar from "./NewNavbar";

const HarbolnasButton = "https://kickavenue-assets.s3.amazonaws.com/assets-image/event-floating-button.png";

// import KickDrawer from './KickDrawer';

class Layout extends Component {
  state = {
    isOpen: false,
    isOpenTriggerDownload: false,
    status_code: 200,
    harbolnasButton: "https://kickavenue-assets.s3.amazonaws.com/assets-image/event-floating-button.png",
    prizeAvailability: false,
    spinWheelButton: "https://kickavenue-assets.s3.amazonaws.com/event/lucky-spin.png",
    bcaButton: "https://kickavenue-assets.s3.amazonaws.com/assets-image/kickavenuebutton.gif",
    spinWheelBca: "https://kickavenue-assets.s3.amazonaws.com/event/lucky-spin-cny.png",
    isRequiredHardRefresh: false,
  };

  async componentDidMount() {
    const latestShownModal = await localStorage.getItem(
      SHOW_TRIGGER_DOWNLOAD_MODAL
    );
    const currentDate = moment().format("YYYY-MM-DD");
    const willShowModal =
      !latestShownModal || moment(currentDate).isAfter(latestShownModal);

    this.props.getKickFairSetting();

    if (willShowModal) this.setState({ isOpenTriggerDownload: true });

    const { getSpinningWheel } = this.props

    getSpinningWheel()
      .then(res => {
        if (res.value.data.length >= 1) {
          this.setState({
            prizeAvailability: true
          })
        }
      })
      .catch(e => null)
  }

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen }, () => {
      if (this.state.isOpen) {
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.height = 0;
      } else {
        document.body.style.overflow = "scroll";
        document.body.style.position = "initial";
        document.body.style.height = "100vh";
      }
    });
  };

  _onWheel = e => {
    if (this.state.isOpen) this.toggle();
  };

  handleChangesNavbar() {
    const { location } = this.props;
    const { status_code } = this.state;

    if (this.props.isMaintenanceMode) return null;

    if (location.pathname.includes('/kickavenews')) return null;

    return <Navbar />

    // if (~location.pathname.indexOf("reactxdisruptor")) {
    //   return <HeaderRaffle />;
    // }
    // if (~location.pathname.indexOf("common-grounds")) {
    //   return <HeaderCommonGround />;
    // }
    // return (
    //   <Header
    //     isOpen={this.state.isOpen}
    //     toggle={this.toggle}
    //     navigation={this.props.history}
    //     pathName={location.pathname}
    //   />
    // );
  }

  handleChangesFooter() {
    const { location } = this.props;
    const { status_code } = this.state;

    if (this.props.isMaintenanceMode) return null;

    if (
      ~location.pathname.indexOf("raffle-preview") ||
      ~location.pathname.indexOf("raffle")
    )
      return null;

    if (~location.pathname.indexOf("reactxdisruptor" && "common-grounds")) {
      return <FooterRaffle />;
    }
    return <FooterBlack />;
  }

  _renderMetaTag = () => {
    const meta_description =
      "Marketplace Sneakers terpercaya di Indonesia. Kami menjamin keaslian semua Sneakers yang anda beli atau uang anda kembali.";

    const { location, isKickFairActive } = this.props;

    return (
      <Helmet>
        <meta name="description" content={meta_description} />
      </Helmet>
    );
  };

  goToKickFair = () => {
    this.props.history.push("/spinthewheel");
  };

  clickShowKickFairButton = () => {
    this.setState({
      displayButton: !this.state.displayButton
    })
  }

  renderFloatButton = () => {
    const { location, isKickFairActive } = this.props;
    const { prizeAvailability } = this.state

    if (!prizeAvailability) return null;

    if (location.pathname === "/" || location.pathname === "/sneakers" || location.pathname === "/streetwear" || location.pathname === "/fashion" || location.pathname === "/apparel" || location.pathname === "/luxury" || location.pathname === "/lifestyle" || location.pathname === "/toys" || location.pathname === '/electronics-collectibles' || location.pathname === "/madeindonesia")
      return (
        <a href="/spinthewheel">
          <KickImage
            src={getCloudImageUrl(this.state.spinWheelBca, 150)}
            id="floating-kick-fair"
            className={classNames("floating-kick-button floating-kickavenue-button", {
              "d-none": location.pathname.includes("raffle")
            })}
          />
        </a>
      );

    // if (~location.pathname.indexOf("bcaxkickavenue"))
    //   return (
    //     <a href="/sneakers">
    //       <KickImage
    //         src={KickAvenueButton}
    //         className={classNames("floating-kick-button floating-kickavenue-button", {
    //           "d-none": location.pathname.includes("raffle")
    //         })}
    //       />
    //     </a>
    //   );

    // if (location.pathname === "/spinthewheel")
    //   return (
    //     <KickImage
    //       // src={KickFairButton}
    //       src={KickAvenueButton}
    //       className={classNames(`floating-kick-button`, {
    //         "d-none": location.pathname.includes("raffle")
    //       })}
    //       style={{ opacity: 1, bottom: location.pathname === "/luxury/concierge" ? 50 : null }}
    //       onClick={() => this.props.history.push("/")}
    //     />
    //   );

    return <div />
  };

  render() {
    const { location, dataAuth } = this.props;
    const excludedPage =
      location.pathname.includes("reset-password") ||
      location.pathname.includes("email-verification");
    const { isOpenTriggerDownload } = this.state;
    if (this.props.isMaintenanceMode) return <PageMaintenance />

    return (
      <ComponentWrapper>
        <LoadingBar className="loadingTop" />
        {this.handleChangesNavbar()}
        {this._renderMetaTag()}
        {this.renderFloatButton()}
        <Switch>
          {this.props.routes.map((route, i) => (
            <Router
              key={i}
              {...route}
              onWheel={this._onWheel}
              isMenuMobile={this.state.isOpen}
            />
          ))}
        </Switch>
        <Modal id="hard-refresh" centered show={this.props.isRequiredHardRefresh}>
          <Modal.Body>
            <KickImage src={ConnectionError} alt="..." />
            <p className="title">Connection unstable.</p>
            <p className="text">It seems that we’ve encountered an issue processing your request, please refresh this page.</p>
            <Button onClick={() => window.location.reload(false)}>Refresh</Button>
          </Modal.Body>
        </Modal>
        {this.handleChangesFooter()}
        {/* {isOpenTriggerDownload && !excludedPage && <TriggerDownloadModal />} */}
      </ComponentWrapper>
    );
  }
}

const mapStateToProps = state => ({
  isKickFairActive: state.dataKaFair.isKickFairActive,
  isMaintenanceMode: state.dataUi.isMaintenanceMode,
  isRequiredHardRefresh: state.dataUi.isRequiredHardRefresh,
  countdown_modal: state.dataMenu.countdown_modal,
  dataAuth: state.dataAuth,
});

const mapDispatchToProps = dispatch => ({
  getKickFairSetting: () => dispatch(getKickFairSetting()),
  getSpinningWheelPrize: (id) => dispatch(getSpinningWheelPrize(id)),
  getSpinningWheel: () => dispatch(getSpinningWheel())
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);